import { connect } from 'react-redux';

import { closeModal, openModal } from 'actions/modal';
import { MODAL_UPDATE_FEEDITEM, MODAL_DELETE_FEEDITEM } from 'types/modal';
import { actions } from '@amplement/backend-connector';
import Component from './index';

const mapStateToProps = state => ({
    initialValues: state.modal[MODAL_UPDATE_FEEDITEM]
});

const mapDispatchToProps = (dispatch) => ({
    onClose: () => dispatch(closeModal(MODAL_UPDATE_FEEDITEM)),
    onSubmit: ({ _feed, _feedItem, feedItem }, form) => {
        if (form.getState().dirty) {
            if (!feedItem?.content) {
                dispatch(
                    openModal(MODAL_DELETE_FEEDITEM, { _feed, _feedItem, content: feedItem?.content })
                );
            } else {
                dispatch(actions.feedItems.requestPatchFeedItem(_feed, {
                    ...feedItem,
                    id: _feedItem
                }));
            }
        }
        dispatch(closeModal(MODAL_UPDATE_FEEDITEM));
        return false;
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
